import { observable, action, computed } from 'mobx';
import { iDoxService } from 'Store/services/index'
import { store } from 'Store/store.index';
import * as APP_CONSTANTS from 'Constants/app.constant';

import { storageGetItem, storageSetItem/* , isPdfOnlineDomain*/, isDemo4Domain/* , isAzk8sDomain */  } from 'Utils/utils';

const aiPreference = JSON.parse(storageGetItem(localStorage, 'aiPreference')) || {};
// Non-Disclosure-Agreement Purchase-Agreement
const checkNDA = (contractType) => /non\-disclosure\-agreement/.test(contractType);
const checkPA = (contractType) => /purchase\-agreement/.test(contractType)

class IDoxStore {
  constructor() {

  }
  // {'check-document'}
  @observable.ref aiPreference = { ...aiPreference };
  @observable documentType = '';
  @observable contractType = '';
  //Non-Disclosure-Agreement
  @observable isNDA = false;
  @observable isNDAFromServer = false;
  @computed get isCheckDocument() {
    return this.aiPreference['check-document'] !== 'no';
  }
  @computed get isNDAOrPA() {
    let flag = checkNDA(this.contractType) || checkPA(this.contractType)
    return flag;
  }
  @action initialize() {
    iDoxService.initialize();
    // listen 
    this.doListenOnOpenFile();
  }
  @action doListenOnOpenFile() {
    //
    let isSupportIdox = false;
    if (/* isPdfOnlineDomain() || */ isDemo4Domain() /* || isAzk8sDomain() */) {
      isSupportIdox = true;
    }
    if (!isSupportIdox) {
      return;
    }

    store.appStore.addAppEventListener(APP_CONSTANTS.SDK_RENDER_FIRST_PAGE, () => {
      if (!this.isCheckDocument) {
        return;
      }
      let handle = setTimeout(() => {
        clearTimeout(handle);
        this.analyzeDocument();
      }, 5000);
    });
    store.appStore.addAppEventListener(APP_CONSTANTS.SDK_WILL_CLOSE_DOC, () => {
      this.doCleanIDoxInfo();
    })
  }
  @action doCleanIDoxInfo(isStop) {
    this.documentType = '';
    this.contractType = '';
    this.isNDA = false;
    this.isNDAFromServer = false;
    //
    if (isStop) {
      this.aiPreference['check-document'] = 'no';
      storageSetItem(localStorage, 'aiPreference', JSON.stringify(this.aiPreference));
    }
  }
  @action updateNDA(isNDA) {
    this.isNDA = isNDA;
  }
  @action checkNDA() {
    let flag = checkNDA(this.contractType)
    return flag;
  }
  @action doAnalyzeDocument() {
    if (this.aiPreference['check-document'] === 'no') {
      return;
    }
    this.analyzeDocument()
  }
  @action analyzeDocument() {
    if (!store.viewer.hasDocument()) {
      return;
    }
    let _this = this;
    const success = (content) => {
      // check
      this.checkDocumentType({ content }).then((result) => {
        //console.log('===>>> ~ IDoxStore ~ this.checkDocumentType ~ result', result);
        const { ret, data } = result;
        if (ret === 0 && data && data.type) {
          const { type, subType } = data;
          if (type.toLowerCase() !== APP_CONSTANTS.AI_DOCUMENT_TYPE_CONTRACT) {
            return;
          }
          //
          _this.documentType = type.toLowerCase();
          if (subType) {
            _this.contractType = subType.toLowerCase();
            if (!checkNDA(_this.contractType)) {
              return;
            }
            _this.isNDA = _this.isNDAFromServer = true;
          }
        }
      }).catch((e) => {
        console.error('===>>> ~ IDoxStore ~ this.checkDocumentType ~ e', e);

      })
    };

    store.viewer.exportToString({}).then((content) => {
      //console.log('===>>> ~ IDoxStore ~ store.viewer.exportToTxt ~ content', content);
      success(content);
    }).catch((e) => {
      console.error('===>>> ~ IDoxStore ~ store.viewer.exportToTxt ~ e', e);

    })
  }
  /**@returns {Promise<String>} contract general invoice research*/
  @action checkDocumentType({ content }) {
    return iDoxService.checkDocumentType({ content });
  }
}

export default IDoxStore;